// extracted by mini-css-extract-plugin
export default {"deleteBtn":"style_deleteBtn__Fsuk-","trashIcon":"style_trashIcon__n-Mxq"};